import { Box, Grid, FormGroup, FormControlLabel, FormControl, Radio, Checkbox, Typography, RadioGroup } from "@mui/material"
import { ShopvisitTable } from "./custom_table"
import { STableLoader } from "../../../shared_elements";

const SvClaimDetails = ({ claimData, isLoading, onFieldChange, modeType, pltConstants, onMultiFieldChange,isReserveRate,error,onFocusChange }) => {
  const claimType = pltConstants?.constant_types?.filter(item => item.type === 'claim_type')?.filter(ele => ele.value !== 3)?.sort((a, b) => Number(a.value) - Number(b.value));
  const claimEventType = pltConstants?.constant_types?.filter(item => item.type === 'claim_event_type')?.sort((a, b) => Number(a.value) - Number(b.value));
  let updatedClaimEventType
  if (claimData?.claim_type?.value === 2) { updatedClaimEventType = claimEventType }
  else { updatedClaimEventType = claimEventType?.filter(ele => ele.value !== 3) }
  return (
    <Box className="escalation-container">
      <Box className="escalation-box">
        {claimData?.major_assembly?.asset_type === 2? <Box>
          <Grid size={{ md: 6, xs: 12 }} sx={{ display: "flex" }}>
            {claimType?.length > 0 ? claimType?.map((claim, index) => (<Grid key={index} size={{ md: isReserveRate ? 4 :6, xs: 12 }}>
              <FormGroup className='disabled-checkbox-wrapper' sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
                <FormControlLabel control={<Checkbox checked={claimData?.claim_type?.value === claim.value} disableRipple onChange={(e) => onFieldChange('claim_type', { value: Number(claim?.value), label: claim?.label })} disabled={modeType === 'view' } />} label={`${claim?.label } ${claim?.value === 1 ? "Event" : "Replacement"}`} />
              </FormGroup>
            </Grid>)
            ) : null}
          </Grid>
          <Typography className='section-header-text'><u>{claimData.claim_type?.value === 1 ? "PRSV Event Details: " : "LLP Replacement Details" }</u></Typography>
          <Grid item xs={12} md={4} sx={{cursor: modeType === "view" ? "not-allowed" : "pointer"}}>
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={claimData?.claim_event_type?.value}
                onChange={(e) => {
                  const label = updatedClaimEventType.find(opt => opt.value === Number(e.target.value))?.label || '';
                  onFieldChange('claim_event_type', {value: Number(e.target.value),label: label});
                }}
              >
                {updatedClaimEventType?.map((eventType, index) => (
                  <FormControlLabel
                    key={index}
                    value={eventType.value}
                    control={<Radio />}
                    label={`${claimData.claim_type?.value === 1 ? "Engine" : "LLP"} ${eventType.label}`}
                    disabled={modeType === 'view'}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
          {[2, 3].includes(claimData?.claim_event_type?.value)? <Grid item xs={12} md={12} mb={2}>
            {isLoading?.skeletonLoader ? <STableLoader count={!isReserveRate ? claimData?.claim_event_type?.value === 3 ? 4 : 3 : claimData?.claim_event_type?.value === 3 ? 3 : 2} rowCount={4} /> : <ShopvisitTable modeType={modeType} claimData={claimData} onMultiFieldChange={onMultiFieldChange} isReserveRate={isReserveRate} error={error}  onFocusChange={onFocusChange}/>}
          </Grid> : null}
        </Box> : null}
      </Box>
    </Box>
  )
}

export default SvClaimDetails